
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'triangle': {
    width: 5,
    height: 10,
    viewBox: '0 0 5 10',
    data: '<path d="M5 0L0 5L5 10L5 0Z" fill="#93A0BD"/>'
  }
})
